import { FeatureToggleClientService } from 'feature-toggle-client';
const useFooterWithBlipStatus = 'use-footer-with-blip-status';
export class CrossAppFeatures {
    static async useFooterWithBlipStatus() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(useFooterWithBlipStatus, false);
    }
}
